import React from 'react';
import { Route } from 'react-router-dom';
import PROFILE from './paths';
import Profile from 'modules/Profile/Profile';
export default function ProfileRoutes() {
  return /*#__PURE__*/React.createElement(Route, {
    path: PROFILE,
    exact: true
  }, /*#__PURE__*/React.createElement(Profile, null));
}